export const globalProgressBarOptions = {
  color: '#8AD4C1',
  failedColor: '#de623b',
  thickness: '6px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}
